// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_landing_landing_module_ts":"68ba4ffaea84cf6c3dd1","src_app_error_error_module_ts":"6a976b8d953e775867ac"}[chunkId] + ".js";
};